import type { DiagramSlownessKind } from '../types/DiagramSlowness.types';

/*
 * When the diagram counts as unusably slow. The limits are the "poor" thresholds of the measurement
 * protocol (docs/meres), raised to where the diagram stops being usable rather than merely slow.
 */

/** Browser work from a response arriving to the chart being painted. */
export const SLOW_RENDER_MS = 3_000;

/** From a click on a series checkbox to the tick being painted. */
export const SLOW_SELECTION_MS = 1_000;

/** A zoom or pan is unusable when at least this many gaps between its frames are this long (about 4 fps). */
export const SLOW_GESTURE_FRAME_MS = 250;
export const SLOW_GESTURE_FRAME_COUNT = 3;

/** A zoom ends with the first frame painted this long after the last wheel event. */
export const WHEEL_GESTURE_IDLE_MS = 300;

/**
 * How many times a kind must happen in one page load before it is reported, once. A single hiccup
 * (garbage collection, the machine busy for a moment) never reaches Sentry.
 */
export const SLOWNESS_OCCURRENCES_TO_REPORT: Record<DiagramSlownessKind, number> = {
  render: 2,
  zoom: 2,
  pan: 2,
  selection: 3,
};

/** Master switch: false turns the whole measurement off, nothing is watched and nothing is sent. */
export const SLOWNESS_REPORTING_ENABLED = true;

/**
 * Share of browser sessions that are measured at all (0 to 1). The rest do not even watch, so a
 * widespread slowness cannot use up the Sentry quota. Raise it when too little data arrives.
 */
export const SLOWNESS_SAMPLE_RATE = 0.1;
